/* Configuratore cornici del campionario (sorgente: repository Core, shopify-theme/luxarts).
 * Il prezzo segue src/lib/frame-shop.js di Core: metri = perimetro + 8 × profilo, × €/m al pubblico
 * (k, già con ricarico, IVA e quota d'acquisto), con il prezzo minimo m (metri minimi del privato),
 * poi il gradino "…4,90 / …9,90" della scala.
 * La cornice va nel carrello come variante del prodotto "Cornice personalizzata" con quel prezzo. */
(function () {
  "use strict";
  var cfgEl = document.getElementById("cc-config");
  var root = document.getElementById("cc-root");
  if (!cfgEl || !root || root.dataset.ready) return;
  root.dataset.ready = "1";
  var cfg = JSON.parse(cfgEl.textContent);
  var product = cfg.product;

  var MATERIAL_BASE = { "TELAIO INTERNO": "canvas", "POSTER ARROTOLATO": "poster" };
  var COLOR_DOTS = {
    "Nero": "#161616", "Bianco": "#fafafa", "Avorio e beige": "#e8dcc3", "Grigio": "#8d8f93", "Oro": "linear-gradient(135deg,#a77b2a,#f1d27c,#a77b2a)",
    "Argento": "linear-gradient(135deg,#8a8c8f,#e6e7e8,#8a8c8f)", "Bronzo e rame": "#8c5a2b", "Legno": "#9b6b43", "Rosso": "#b3262d", "Rosa": "#e7a1b6",
    "Arancione": "#e8792c", "Giallo": "#e2bd2f", "Verde": "#4f8a55", "Blu e azzurro": "#2f5f9e", "Viola": "#7d5aa6",
    "Multicolore": "conic-gradient(#e33,#fc3,#3c6,#39f,#c3f,#e33)"
  };
  var WALL_CM = 400;
  var DEFAULT_FRAME = "C-5494"; // cornice di partenza scelta dall'utente il 28/10/2026
  var PAGE = 24;

  var sizeIdx = -1, matIdx = -1, baseValue = null, kind = null;
  product.options.forEach(function (name, i) {
    var n = String(name).toLowerCase();
    if (n.indexOf("dimension") === 0) sizeIdx = i;
    if (n.indexOf("materiale") === 0 || n === "material") matIdx = i;
  });
  if (sizeIdx < 0 || matIdx < 0) return;
  product.variants.some(function (v) {
    var m = String(v.options[matIdx]).trim();
    if (MATERIAL_BASE[m]) { baseValue = v.options[matIdx]; kind = MATERIAL_BASE[m]; return true; }
    return false;
  });
  if (!kind) return;

  var S = { data: null, frame: null, color: null, style: null, shown: PAGE, view: "photo", touched: false, mat: null, matColor: null, matW: 5, glass: null, mode: "frame", autoPicked: false, retouch: false, tier: "std" };
  var MAT_NEUTRAL = "#f4f1ea"; // passe-partout di cui non si conosce ancora la tinta
  var DOUBLE_PLEXI = "rgba(255, 255, 255, .06)"; // doppio plexiglass: tra stampa e cornice si vede il muro

  function parseSize(text) {
    var m = String(text).replace(",", ".").match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    if (!m || /pz/i.test(text)) return null;
    return { w: parseFloat(m[1]), h: parseFloat(m[2]), label: String(text).trim() };
  }
  function mainForm() { return document.querySelector("form.main-product-form") || document.querySelector('form[action*="/cart/add"]'); }
  function currentVariant() {
    var form = mainForm();
    var input = form && form.querySelector('[name="id"]');
    var id = input ? Number(input.value) : 0;
    return product.variants.filter(function (v) { return v.id === id; })[0] || product.variants[0];
  }
  function currentSizeValue() { return currentVariant().options[sizeIdx]; }
  function baseVariantFor(sizeValue) {
    return product.variants.filter(function (v) { return v.options[sizeIdx] === sizeValue && v.options[matIdx] === baseValue; })[0] || null;
  }
  function meters(w, h, wmm) { return (2 * (w + h)) / 100 + (8 * wmm) / 1000; }
  function ladder(price) { var step = S.data.ladder.step; return Math.max(1, Math.ceil((price + 0.1) / step)) * step - 0.1; }
  function frameRaw(f, w, h) { return Math.max(meters(w, h, f.w) * f.k, f.m || 0); }
  function framePrice(f, size) { return ladder(frameRaw(f, size.w, size.h)); }
  // Cornici standard: le varianti "CON CORNICE <colore>" del prodotto (profilo 2,5 cm), vendute al loro prezzo.
  function normMat(m) { return String(m || "").replace(/\s+/g, " ").trim().toUpperCase(); }
  function stdVariant(f, sizeValue) {
    return product.variants.filter(function (v) { return v.options[sizeIdx] === sizeValue && normMat(v.options[matIdx]) === "CON CORNICE " + f.key && v.available !== false; })[0] || null;
  }
  function stdList(sizeValue) {
    return ((S.data && S.data.standard) || []).filter(function (f) { return stdVariant(f, sizeValue); }).map(function (f) {
      var o = {}; for (var k in f) o[k] = f[k];
      o.std = true; o.label = f.name; o.name = "Cornice standard " + f.name.toLowerCase(); o.code = "standard " + f.key;
      return o;
    });
  }
  // Poster: la misura scelta (es. 70x100) comprende il passe-partout o il bordo trasparente del doppio
  // plexiglass: la cornice si calcola su quella misura e la stampa si riduce di due volte il bordo.
  function matCm(size) {
    if (kind === "canvas") return S.mat ? S.matW : 0; // tela: effetto passe-partout stampato, anche senza cornice
    return kind === "poster" && S.frame && !S.frame.std && (S.mat || S.glass === "doppio") ? S.matW : 0;
  }
  function printSize(size) { var b = matCm(size); return { w: size.w - 2 * b, h: size.h - 2 * b, label: size.label }; }
  function matColors() {
    if (kind === "canvas") return (S.data.extras && S.data.extras.matColors) || []; // tela: i colori del passe-partout dei poster
    var all = (S.data.extras && S.data.extras.matColors) || [];
    var t = S.mat === "pas28" ? 2.8 : 1.4;
    return all.filter(function (c) { return !c.thick || c.thick.indexOf(t) >= 0; });
  }
  // Al cliente niente codici: il nome del colore (o "Colore n" finché il catalogo non ha i nomi).
  function matLabel(c, i) { return c.name || "Colore " + (i + 1); }
  // Tela: l'effetto passe-partout è un prodotto a parte a prezzo fisso (addons.printedMat, creato da Core).
  function printedMat() { return (S.data.addons && S.data.addons.printedMat) || null; }
  function printedMatFee() { var a = printedMat(); return kind === "canvas" && S.mat && a ? Number(a.price) : 0; }
  // Tela: ritocco a mano (un'artista ritocca la tela e la rende materica), prodotto a parte a prezzo fisso.
  function retouchAddon() { return (S.data.addons && S.data.addons.retouch) || null; }
  function retouchFee() { var a = retouchAddon(); return kind === "canvas" && S.retouch && a ? Number(a.price) : 0; }
  // Il ritocco si offre solo sulle tele con il tag "ritocco a mano" (o "ritocco"): i quadri non fotografici.
  var RETOUCH_OK = kind === "canvas" && (product.tags || []).some(function (t) { return /^ritocco( a mano)?$/i.test(String(t).trim()); });
  function matHex() {
    var c = matColors().filter(function (x) { return x.code === S.matColor; })[0];
    return (c && c.hex) || MAT_NEUTRAL;
  }
  // Colori del passe-partout come pallini (sono decine: i cartoncini del campionario), con il nome di quello scelto sotto.
  function matColorsHtml(cols) {
    var cur = cols.filter(function (c) { return c.code === S.matColor; })[0];
    return '<div class="cc__opts"><span class="cc__optlabel">Colore</span><div class="cc__matcolors">' + cols.map(function (c, i) {
      return '<button type="button" class="cc__mcol" data-matcolor="' + esc(c.code) + '" aria-pressed="' + (S.matColor === c.code) + '" title="' + esc(matLabel(c, i)) + '" aria-label="' + esc(matLabel(c, i)) + '"><span style="background:' + (c.hex || MAT_NEUTRAL) + '"></span></button>';
    }).join("") + "</div>" + (cur ? '<small class="cc__hint">' + esc(matLabel(cur, cols.indexOf(cur))) + "</small>" : "") + "</div>";
  }
  function extraPrice(key, w, h) {
    var x = S.data.extras, o = x && x.options && x.options[key];
    if (!o) return null;
    for (var i = 0; i < x.sizes.length; i++) {
      var p = String(x.sizes[i]).split("x").map(Number);
      if ((w <= p[0] && h <= p[1]) || (w <= p[1] && h <= p[0])) return o.prices[i] == null ? null : Number(o.prices[i]);
    }
    return null;
  }
  // Riga "Cornice personalizzata": cornice sulla misura scelta + aggiunte, poi il gradino della scala.
  function linePrice(size) {
    var total = frameRaw(S.frame, size.w, size.h);
    if (kind === "poster" && S.mat) total += extraPrice(S.mat, size.w, size.h) || 0;
    if (kind === "poster" && S.glass) total += extraPrice(S.glass === "doppio" ? "doppioVetro" : "plexi", size.w, size.h) || 0;
    return ladder(total);
  }
  function outerCm(size) {
    var add = S.frame ? S.frame.w / 10 + (S.frame.gap || 0) / 10 : 0;
    return { w: size.w + 2 * add, h: size.h + 2 * add };
  }
  function frameVariant(price) { return S.data.ladder.variants[price.toFixed(2)] || null; }
  function eur(n) { return "€ " + n.toFixed(2).replace(".", ","); }
  function money(n) { return "€" + n.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."); } // come il prezzo del tema
  function cm(n) { return String(Math.round(n * 10) / 10).replace(".", ","); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function imgUrl(f) { return cfg.assetBase + f.img; }

  // Il Materiale lo decide il configuratore: si nasconde la scelta e si resta sulla versione base.
  // Il tema ridisegna la scelta della variante a ogni cambio di misura (in modo asincrono): la regola CSS
  // nasconde il gruppo Materiale anche nell'HTML nuovo, l'observer riallinea la scelta e il configuratore.
  function hideMaterialRule() {
    if (document.getElementById("cc-hide-material")) return;
    var v = String(baseValue).replace(/["\\]/g, "\\$&");
    var st = document.createElement("style");
    st.id = "cc-hide-material";
    st.textContent = 'variant-selects fieldset:has(input[value="' + v + '"]), variant-radios fieldset:has(input[value="' + v + '"]), variant-selects .product-form__input:has(option[value="' + v + '"]) { display: none !important; }';
    document.head.appendChild(st);
  }
  var lastSize = null, pickerTimer = null;
  function watchPicker() {
    var picker = document.querySelector("variant-selects, variant-radios");
    var host = picker && (picker.closest(".product__block") || picker.parentElement);
    if (!host || !window.MutationObserver) return;
    new MutationObserver(function () {
      clearTimeout(pickerTimer);
      pickerTimer = setTimeout(function () {
        hideMaterial();
        var now = currentSizeValue();
        if (now !== lastSize) render();
      }, 30);
    }).observe(host, { childList: true, subtree: true });
  }

  function hideMaterial() {
    hideMaterialRule();
    document.querySelectorAll("variant-selects fieldset, variant-radios fieldset, .product-form__input").forEach(function (fs) {
      var legend = fs.querySelector("legend, label");
      if (legend && /^\s*materiale/i.test(legend.textContent)) fs.style.display = "none";
    });
    var radios = document.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === baseValue && !radios[i].checked) { radios[i].click(); break; }
    }
    document.querySelectorAll("variant-selects select").forEach(function (sel) {
      for (var j = 0; j < sel.options.length; j++) {
        if (sel.options[j].value === baseValue && sel.value !== baseValue) { sel.value = baseValue; sel.dispatchEvent(new Event("change", { bubbles: true })); }
      }
    });
  }

  function available() {
    return S.data.frames.filter(function (f) { return kind === "poster" || f.use === "tela"; });
  }
  // Premium in ordine di colore (come i pallini) e, dentro lo stesso colore, dal prezzo più basso per la misura scelta.
  function filtered() {
    var size = parseSize(currentSizeValue()), colors = S.data.colors || [];
    var price = function (f) { return size ? frameRaw(f, size.w, size.h) : f.k; };
    return available().filter(function (f) { return (!S.color || f.color === S.color) && (!S.style || f.style === S.style); })
      .sort(function (a, b) { return (colors.indexOf(a.color) - colors.indexOf(b.color)) || (price(a) - price(b)); });
  }

  function cornerHtml(f) {
    var b = Math.max(8, Math.min(26, f.w / 2.2));
    return '<span class="cc__corner"><i style="border-width:' + b + "px;border-image:url(" + imgUrl(f) + ") " + (f.slice * 100).toFixed(2) + '% stretch"></i></span>';
  }

  function render() {
    var size = parseSize(currentSizeValue());
    if (!size) { root.hidden = true; hideStage(); document.documentElement.classList.remove("cc-on"); return; }
    root.hidden = false;
    lastSize = currentSizeValue();
    var list = available();
    var colors = S.data.colors.filter(function (c) { return list.some(function (f) { return f.color === c; }); });
    var styles = S.data.styles.filter(function (s) { return list.some(function (f) { return f.style === s && (!S.color || f.color === S.color); }); });
    var shown = filtered();
    var stds = stdList(currentSizeValue());
    if (S.frame && !(S.frame.std ? stds : list).some(function (f) { return f.id === S.frame.id; })) S.frame = null;
    if (S.frame && S.frame.std) { S.tier = "std"; if (kind === "poster") { S.mat = null; S.glass = null; } }

    // Prima scelta esplicita: la versione base (poster arrotolato / solo telaio) oppure con cornice.
    // La fila delle cornici compare solo con "Con cornice". Sezione compatta: prezzo e carrello senza scorrere.
    if (S.frame) S.mode = "frame";
    // All'apertura "Con cornice" con la prima cornice Standard e la foto del prodotto (richiesta dell'utente del
    // 29/10/2026): l'anteprima con la cornice compare quando il cliente sceglie una cornice. Senza cornici Standard,
    // o aprendo Premium, la cornice scelta dall'utente (Barocca intagliata avorio con filo oro, campione C-5494; in
    // mancanza una nera moderna o la prima disponibile) con l'anteprima già sulla foto.
    if (S.mode === "frame" && !S.frame && !S.autoPicked && S.tier === "std" && stds.length) {
      S.autoPicked = true;
      S.frame = stds[0];
      S.touched = true; S.view = "photo";
    }
    if (S.mode === "frame" && !S.frame && !S.autoPicked) {
      S.autoPicked = true;
      var okF = list.filter(function (f) { return frameVariant(framePrice(f, size)); });
      S.frame = okF.filter(function (f) { return f.id === DEFAULT_FRAME; })[0] ||
        okF.filter(function (f) { return f.color === "Nero" && f.style === "Moderno"; })[0] || okF[0] || null;
      if (S.frame) { S.touched = true; S.view = "frame"; }
    }
    var baseV = baseVariantFor(currentSizeValue());
    var minFrame = list.reduce(function (m, f) { var p = framePrice(f, size); return frameVariant(p) && p < m ? p : m; }, Infinity);
    stds.forEach(function (f) { var v = stdVariant(f, currentSizeValue()); if (v && baseV) minFrame = Math.min(minFrame, (v.price - baseV.price) / 100); });
    var modeBtn = function (val, title, sub, price) {
      return '<button type="button" class="cc__mode-btn" data-mode="' + val + '" aria-pressed="' + (S.mode === val) + '" title="' + esc(sub) + '"><b>' + title + "</b><span>" + price + "</span></button>";
    };
    var h = '<div class="cc__mode" role="group" aria-label="Versione">' +
      modeBtn("base", kind === "poster" ? "Poster arrotolato" : "Solo telaio", kind === "poster" ? "senza cornice, spedito in tubo" : "tela sul telaio, senza cornice", baseV ? money(baseV.price / 100) : "") +
      modeBtn("frame", kind === "poster" ? "Personalizza con cornice" : "Telaio e cornice esterna", (stds.length + list.length) + " cornici", "") + "</div>"; // senza "da +…" (richiesta dell'utente)
    // Ben in vista: arriva pronto da appendere (tele sempre, poster solo con la cornice; il poster arrotolato no).
    if (kind === "canvas" || S.mode === "frame") h += '<div class="cc__ready"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="3.5" r="1.3"/><path d="M12 4.8 6 10M12 4.8 18 10"/><rect x="4" y="10" width="16" height="11" rx="1"/></svg>' +
      "<span><b>Spedito pronto da appendere</b> lo ricevi già montato, basta appenderlo alla parete</span></div>";

    if (S.mode === "frame") {
      // Cornici standard (le quattro di sempre, variante del prodotto) e premium (campionario)
      var tabs = stds.length ? '<div class="cc__tiers" role="group" aria-label="Tipo di cornice">' +
        '<button type="button" class="cc__tier" data-tier="std" aria-pressed="' + (S.tier === "std") + '"><b>Standard</b><small>' + stds.length + " colori · profilo 2,5 cm</small></button>" +
        '<button type="button" class="cc__tier" data-tier="premium" aria-pressed="' + (S.tier === "premium") + '"><b>Premium</b><small>' + list.length + " cornici del campionario</small></button></div>"
        : '<span class="cc__title">Cornice <small>' + list.length + " nel campionario</small></span>";
      h += '<div class="cc__head">' + tabs + (S.tier === "std" && stds.length ? "" :
        '<div class="cc__seg" role="group" aria-label="Stile">' +
        [["", "Tutte"], ["Moderno", "Moderne"], ["Antico", "Antiche"]].filter(function (s) { return !s[0] || styles.indexOf(s[0]) >= 0; }).map(function (s) {
          return '<button type="button" data-style="' + s[0] + '" aria-pressed="' + ((S.style || "") === s[0]) + '">' + s[1] + "</button>";
        }).join("") + "</div>") + "</div>";
    }
    if (S.mode === "frame" && S.tier === "std" && stds.length) {
      h += '<div class="cc__rail cc__rail--std">' + stds.map(function (f) {
        var v = stdVariant(f, currentSizeValue()), d = v && baseV ? (v.price - baseV.price) / 100 : 0;
        return '<button type="button" class="cc__sw" data-frame="' + f.id + '" aria-pressed="' + Boolean(S.frame && S.frame.id === f.id) + '" title="' + esc(f.name) + '">' +
          cornerHtml(f) + '<span class="cc__swname">' + esc(f.label) + '</span><span class="cc__swprice">+ ' + eur(d) + "</span></button>";
      }).join("") + "</div>";
    } else if (S.mode === "frame") {
      h += '<div class="cc__colors" role="group" aria-label="Colore">' +
        '<button type="button" class="cc__cdot cc__cdot--all" data-color="" aria-pressed="' + !S.color + '" title="Tutti i colori">Tutti</button>' +
        colors.map(function (c) {
          return '<button type="button" class="cc__cdot" data-color="' + esc(c) + '" aria-pressed="' + (S.color === c) + '" title="' + esc(c) + '" aria-label="' + esc(c) + '"><span style="background:' + (COLOR_DOTS[c] || "#ccc") + '"></span></button>';
        }).join("") + (S.color ? '<span class="cc__cname">' + esc(S.color) + "</span>" : "") + "</div>";

      // Fila che scorre di lato, con frecce e rotella del mouse; "Vedi tutte" la apre su più righe.
      h += '<div class="cc__railwrap' + (S.expanded ? " is-all" : "") + '"><button type="button" class="cc__nav cc__nav--prev" data-nav="-1" aria-label="Cornici precedenti">‹</button>' +
        '<div class="cc__rail' + (S.expanded ? " cc__rail--all" : "") + '">';
      shown.forEach(function (f) {
        var p = framePrice(f, size);
        var ok = Boolean(frameVariant(p));
        h += '<button type="button" class="cc__sw" data-frame="' + f.id + '" aria-pressed="' + (S.frame && S.frame.id === f.id) + '"' + (ok ? "" : " disabled") + ' title="' + esc(f.name) + '">' +
          cornerHtml(f) + '<span class="cc__swname">' + esc(f.name) + '</span><span class="cc__swprice">' + (ok ? "+ " + eur(p) : "non disponibile") + "</span></button>";
      });
      h += '</div><button type="button" class="cc__nav cc__nav--next" data-nav="1" aria-label="Cornici successive">›</button></div>';
      h += '<button type="button" class="cc__all" data-all="1">' + (S.expanded ? "Mostra in una riga" : "Vedi tutte le " + shown.length + " cornici") + "</button>";
    }

    var base = baseVariantFor(currentSizeValue());
    var basePrice = base ? base.price / 100 : 0;
    var baseFull = base && base.compare_at_price > base.price ? base.compare_at_price / 100 : basePrice;
    var what = kind === "poster" ? "Poster" : "Quadro";
    if (!S.frame && kind === "poster") { S.mat = null; S.glass = null; }
    var stdV = S.frame && S.frame.std ? stdVariant(S.frame, currentSizeValue()) : null;
    var fp = S.frame ? (stdV ? (stdV.price - (base ? base.price : 0)) / 100 : linePrice(size)) : 0;
    var fpFull = stdV ? ((stdV.compare_at_price > stdV.price ? stdV.compare_at_price : stdV.price) / 100 - baseFull) : fp;
    var out = outerCm(size);
    if (S.frame) {
      h += '<div class="cc__line"><b>' + esc(S.frame.name) + "</b> · profilo " + cm(S.frame.w / 10) + " cm · ingombro " +
        cm(out.w) + " × " + cm(out.h) + " cm · su misura per questo " + what.toLowerCase() +
        (matCm(size) ? " · misura " + esc(size.label) + " con " + (S.mat ? "passe-partout" : "bordo trasparente") + " incluso, stampa " + cm(printSize(size).w) + " × " + cm(printSize(size).h) + " cm" : "") + "</div>";
      if (kind === "poster" && S.data.extras && !S.frame.std) h += extrasHtml(size);
    } else if (S.mode === "frame") {
      h += '<div class="cc__line"><b>Scegli una cornice</b> dalla fila qui sopra: il prezzo si aggiorna con la misura.</div>';
    }
    if (kind === "canvas") h += printedMatHtml(size) + (RETOUCH_OK ? retouchHtml() : "");
    // Il prezzo del tema sotto il titolo è nascosto (classe cc-on): il prezzo lo mostra sempre questo blocco.
    // Lo sconto barrato è quello del quadro (compare_at_price della variante): la cornice non ha un prezzo pieno diverso.
    var pmFee = printedMatFee(), rtFee = retouchFee();
    var total = basePrice + fp + pmFee + rtFee, totalFull = baseFull + fpFull + pmFee + rtFee;
    h += '<div class="cc__buy"><button type="button" class="cc__ar" data-ar="1"><span aria-hidden="true">◱</span> Provalo sulla tua parete</button>' +
      '<div class="cc__price"><span class="cc__price-label">' + (S.frame ? "Totale " + what.toLowerCase() + " con cornice" : what + " " + esc(size.label)) + "</span>" +
      '<div class="cc__price-row"><span class="cc__price-now">' + money(total) + "</span>" +
      (totalFull > total ? '<s class="cc__price-was">' + money(totalFull) + '</s><span class="cc__price-save">-' + money(totalFull - total) + "</span>" : "") + "</div>" +
      "</div></div>";
    // Con la cornice il quadro diventa un prodotto personalizzato: lo si dice subito sopra "Aggiungi al carrello".
    if ((S.mode === "frame" && S.frame) || (kind === "canvas" && S.mat)) h += '<p class="cc__made"><b>Prodotto personalizzato:</b> lo realizziamo su misura per te con la configurazione scelta.</p>';
    document.documentElement.classList.add("cc-on");
    var rail = root.querySelector(".cc__rail");
    var railX = rail ? rail.scrollLeft : 0;
    root.innerHTML = h;
    var railNew = root.querySelector(".cc__railwrap .cc__rail"); // solo la fila premium ha le frecce
    if (railNew) {
      railNew.scrollLeft = S.expanded ? 0 : railX;
      var selSw = !S.expanded && !railX && railNew.querySelector('.cc__sw[aria-pressed="true"]');
      if (selSw) railNew.scrollLeft = Math.max(0, selSw.offsetLeft - railNew.offsetLeft - 8); // la cornice scelta resta in vista
      setupRail(railNew);
    }
    // Il pagamento rapido (Shop Pay e simili) salterebbe la riga della cornice: con una cornice scelta si nasconde.
    var addLines = S.mode === "frame" || (kind === "canvas" && (S.mat || S.retouch)); // righe in più che il pagamento rapido salterebbe
    document.querySelectorAll(".shopify-payment-button").forEach(function (el) { el.style.display = addLines ? "none" : ""; });
    renderStage();
    showRetouch();
  }

  // Tela: effetto passe-partout stampato sulla tela (nessuno spessore), larghezza e colore, compreso nella misura.
  function printedMatHtml(size) {
    var hh = '<div class="cc__opts"><span class="cc__optlabel">Passe-partout</span><div class="cc__seg">' +
      '<button type="button" data-mat="" aria-pressed="' + !S.mat + '">Nessuno</button>' +
      '<button type="button" data-mat="print" aria-pressed="' + (S.mat === "print") + '"' + (printedMat() ? "" : " disabled") + ">Effetto passe-partout" + (printedMat() ? " <small>+" + money(Number(printedMat().price)) + "</small>" : "") + "</button></div>" +
      '<small class="cc__hint">stampato sulla tela: effetto passe-partout, compreso nella misura</small></div>';
    if (!S.mat) return hh;
    var cols = matColors();
    if (!cols.some(function (c) { return c.code === S.matColor; })) S.matColor = cols.length ? cols[0].code : null;
    hh += '<div class="cc__opts"><span class="cc__optlabel">Larghezza</span><div class="cc__seg">' +
      ((S.data.extras && S.data.extras.matWidths) || [3, 5, 8]).map(function (wd) { return '<button type="button" data-matw="' + wd + '" aria-pressed="' + (S.matW === wd) + '">' + wd + " cm</button>"; }).join("") + "</div>" +
      '<small class="cc__hint">compreso nella misura ' + esc(size.label) + ": immagine " + cm(printSize(size).w) + " × " + cm(printSize(size).h) + " cm</small></div>";
    hh += matColorsHtml(cols);
    return hh;
  }

  function retouchHtml() {
    var a = retouchAddon();
    return '<div class="cc__opts"><span class="cc__optlabel">Ritocco a mano</span><div class="cc__seg">' +
      '<button type="button" data-retouch="" aria-pressed="' + !S.retouch + '">No</button>' +
      '<button type="button" data-retouch="1" aria-pressed="' + S.retouch + '"' + (a ? "" : " disabled") + ">Sì" + (a ? " <small>+" + money(Number(a.price)) + "</small>" : "") + "</button></div>" +
      '<small class="cc__hint">un\'artista ritocca a mano la tela e la rende materica, pezzo unico</small></div>';
  }

  function extrasHtml(size) {
    var opt = function (attr, val, on, label, price) {
      return '<button type="button" ' + attr + '="' + val + '" aria-pressed="' + on + '"' + (price === null ? " disabled" : "") + ">" + label + (price ? " <small>+" + money(price) + "</small>" : "") + "</button>";
    };
    var x = S.data.extras.options, ex = S.data.extras;
    var hh = "";
    if (S.glass !== "doppio") {
      hh += '<div class="cc__opts"><span class="cc__optlabel">Passe-partout</span><div class="cc__seg">' +
        opt("data-mat", "", !S.mat, "Nessuno", 0) +
        (x.pas14 ? opt("data-mat", "pas14", S.mat === "pas14", "Spessore 1,4 mm", extraPrice("pas14", size.w, size.h)) : "") +
        (x.pas28 ? opt("data-mat", "pas28", S.mat === "pas28", "Spessore 2,8 mm", extraPrice("pas28", size.w, size.h)) : "") + "</div></div>";
      if (S.mat) {
        var cols = matColors();
        if (!cols.some(function (c) { return c.code === S.matColor; })) S.matColor = cols.length ? cols[0].code : null;
        hh += matColorsHtml(cols);
      }
    }
    if (S.mat || S.glass === "doppio") {
      hh += '<div class="cc__opts"><span class="cc__optlabel">' + (S.mat ? "Larghezza" : "Bordo trasparente") + '</span><div class="cc__seg">' +
        (ex.matWidths || [3, 5, 8]).map(function (wd) { return opt("data-matw", wd, S.matW === wd, wd + " cm", 0); }).join("") + "</div>" +
        '<small class="cc__hint">compreso nella misura ' + esc(size.label) + ": stampa " + cm(printSize(size).w) + " × " + cm(printSize(size).h) + " cm</small></div>";
    }
    if (x.plexi || x.doppioVetro) {
      hh += '<div class="cc__opts"><span class="cc__optlabel">Plexiglass</span><div class="cc__seg">' +
        opt("data-glass", "", !S.glass, "Senza", 0) +
        (x.plexi ? opt("data-glass", "plexi", S.glass === "plexi", "Plexiglass", extraPrice("plexi", size.w, size.h)) : "") +
        (x.doppioVetro ? opt("data-glass", "doppio", S.glass === "doppio", "Doppio plexiglass", extraPrice("doppioVetro", size.w, size.h)) : "") + "</div>" +
        (S.glass === "doppio" ? '<small class="cc__hint">plexiglass fronte e retro: al posto del passe-partout si vede il muro</small>' : "") + "</div>";
    }
    return hh;
  }

  // Frecce visibili solo se c'è altro da vedere da quel lato; la rotella verticale fa scorrere la fila.
  function setupRail(r) {
    var wrap = r.parentNode;
    function nav() {
      var prev = wrap.querySelector(".cc__nav--prev"), next = wrap.querySelector(".cc__nav--next");
      var all = r.classList.contains("cc__rail--all");
      prev.hidden = all || r.scrollLeft <= 2;
      next.hidden = all || r.scrollLeft + r.clientWidth >= r.scrollWidth - 2;
    }
    r.addEventListener("scroll", nav, { passive: true });
    r.addEventListener("wheel", function (e) {
      if (r.classList.contains("cc__rail--all") || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      var max = r.scrollWidth - r.clientWidth;
      if ((e.deltaY > 0 && r.scrollLeft >= max - 1) || (e.deltaY < 0 && r.scrollLeft <= 0)) return; // ai bordi scorre la pagina
      e.preventDefault();
      r.scrollLeft += e.deltaY;
    }, { passive: false });
    nav();
  }

  // ---------- Anteprima sopra la foto ----------
  var stage = null;
  function gallery() { return document.querySelector(".product__media-gallery-viewer-wrap") || document.querySelector("media-gallery"); }
  function hideStage() { if (stage) stage.hidden = true; }
  function ensureStage() {
    if (stage) return stage;
    var g = gallery();
    if (!g) return null;
    if (getComputedStyle(g).position === "static") g.style.position = "relative";
    stage = document.createElement("div");
    stage.className = "cc-stage";
    stage.hidden = true;
    g.appendChild(stage);
    stage.addEventListener("click", function (e) {
      var real = e.target.closest(".cc-real");
      if (real) { e.preventDefault(); e.stopPropagation(); real.classList.toggle("cc-real--big"); return; }
      var b = e.target.closest("[data-view]");
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      S.view = b.getAttribute("data-view");
      renderStage();
    });
    new ResizeObserver(function () { if (!stage.hidden) renderStage(); }).observe(stage);
    return stage;
  }

  function artStyle(size, W, H) {
    var IW = cfg.imageWidth, IH = cfg.imageHeight, b = cfg.box;
    var bx = b.x0 * IW, by = b.y0 * IH, bw = (b.x1 - b.x0) * IW, bh = (b.y1 - b.y0) * IH;
    var target = size.w / size.h;
    var rx = bx, ry = by, rw = bw, rh = bh;
    if (bw / bh > target) { rw = bh * target; rx = bx + (bw - rw) / 2; } else { rh = bw / target; ry = by + (bh - rh) / 2; }
    return "width:" + W + "px;height:" + H + "px;background-image:url(" + cfg.image + ");background-size:" + (IW * W / rw).toFixed(1) + "px " + (IH * H / rh).toFixed(1) + "px;background-position:" + (-rx * W / rw).toFixed(1) + "px " + (-ry * H / rh).toFixed(1) + "px";
  }

  function pieceHtml(size, pxPerCm) {
    var f = S.frame;
    var ps = printSize(size);
    var W = Math.round(ps.w * pxPerCm), H = Math.round(ps.h * pxPerCm);
    var art = '<div class="cc-piece__art" style="' + artStyle(ps, W, H) + '"></div>';
    if (!f) {
      var d = Math.max(2, Math.round(1.6 * pxPerCm));
      var pm = Math.round(matCm(size) * pxPerCm);
      if (pm) art = '<div class="cc-piece__mat" style="padding:' + pm + "px;background:" + matHex() + '">' + art + "</div>";
      return '<div class="cc-piece" style="border-width:0;box-shadow:' + d + "px " + (d * 1.5) + "px " + (d * 4) + 'px rgba(0,0,0,.35)">' + art + "</div>";
    }
    var border = Math.max(3, Math.round((f.w / 10) * pxPerCm));
    var gap = f.gap ? Math.max(2, Math.round((f.gap / 10) * pxPerCm)) : 0;
    var mat = Math.round(matCm(size) * pxPerCm);
    if (mat) art = '<div class="cc-piece__mat' + (S.mat ? "" : " cc-piece__mat--clear") + '" style="padding:' + mat + "px;background:" + (S.mat ? matHex() : DOUBLE_PLEXI) + '">' + art + "</div>";
    if (kind === "poster" && S.glass) art = '<div class="cc-piece__glassed">' + art + '<i class="cc-piece__glass"></i></div>';
    var inner = gap ? '<div class="cc-piece__gap" style="padding:' + gap + 'px">' + art + "</div>" : art;
    return '<div class="cc-piece" style="border-width:' + border + "px;border-image:url(" + imgUrl(f) + ") " + (f.slice * 100).toFixed(2) + '% stretch;filter:drop-shadow(0 ' + Math.round(border / 3 + 3) + "px " + Math.round(border / 1.5 + 8) + 'px rgba(0,0,0,.32))">' + inner + "</div>";
  }

  // Arredi disegnati in centimetri: x dal centro della stanza, y da terra. La parete è larga WALL_CM.
  var ROOMS = {
    sofa: { label: "divano 210 cm", above: 82 + 22, parts: [
      [-99, 34, 198, 48, "#6c6a66"], [-105, 10, 18, 50, "#64625e"], [87, 10, 18, 50, "#64625e"], [-89, 14, 178, 30, "#78756f"],
      [-91, 0, 4, 10, "#3a2c20", 1], [87, 0, 4, 10, "#3a2c20", 1]] },
    bed: { label: "letto matrimoniale 160 cm", above: 115 + 25, parts: [
      [-88, 8, 176, 107, "#b9ab97", 6], [-83, 8, 166, 27, "#8b7b68", 3], [-80, 0, 5, 8, "#3a2c20", 1], [75, 0, 5, 8, "#3a2c20", 1],
      [-80, 35, 160, 20, "#f4f1ea", 4], [-82, 28, 164, 30, "#e6dfd3", 5], [-72, 55, 62, 20, "#f7f5f0", 8], [10, 55, 62, 20, "#f7f5f0", 8],
      [-139, 0, 45, 55, "#7a6a58", 2], [94, 0, 45, 55, "#7a6a58", 2],
      [-122.5, 55, 12, 30, "#cdbfae", 2], [-131.5, 85, 30, 22, "#efe7da", 3], [110.5, 55, 12, 30, "#cdbfae", 2], [101.5, 85, 30, 22, "#efe7da", 3]] },
  };

  function realPhotoHtml() {
    if (!S.frame || !S.frame.real) return "";
    return '<figure class="cc-real" title="Ingrandisci"><img src="' + cfg.assetBase + S.frame.real + '" alt="Foto reale della cornice ' + esc(S.frame.name) + '" onerror="this.parentNode.remove()"><figcaption>Foto reale del campione</figcaption></figure>';
  }

  function renderStage() {
    var size = parseSize(currentSizeValue());
    if (!S.touched || !size || S.view === "photo") {
      if (stage) stage.hidden = true;
      showBack(S.touched && Boolean(size) && S.view === "photo");
      return;
    }
    showBack(false);
    var st = ensureStage();
    if (!st) return;
    st.hidden = false;
    var R = st.getBoundingClientRect();
    var oc = outerCm(size), outW = oc.w, outH = oc.h;
    var views = viewsHtml();
    if (S.view === "frame") {
      var k = Math.min((R.width * 0.8) / outW, (R.height * 0.7) / outH);
      st.innerHTML = views + pieceHtml(size, k) + realPhotoHtml();
      return;
    }
    var room = ROOMS[S.view] || ROOMS.sofa;
    var kk = R.width / WALL_CM, floorY = R.height * 0.82, cx = R.width / 2;
    var parts = room.parts.map(function (p) {
      return '<i style="left:' + (cx + p[0] * kk) + "px;top:" + (floorY - (p[1] + p[3]) * kk) + "px;width:" + p[2] * kk + "px;height:" + p[3] * kk + "px;background:" + p[4] + ";border-radius:" + (p[5] === undefined ? 10 : p[5]) * kk + 'px"></i>';
    }).join("");
    var top = Math.max(R.height * 0.04, floorY - (room.above + outH) * kk);
    st.innerHTML = views + '<div class="cc-room"><div class="cc-room__wall"></div><div class="cc-room__floor"></div>' + parts +
      '<div style="position:absolute;left:50%;top:' + top + 'px;transform:translateX(-50%)">' + pieceHtml(size, kk) + "</div>" +
      '<div class="cc-stage__dim" style="left:50%;top:' + (top + outH * kk + 6) + 'px">' + cm(outW) + " × " + cm(outH) + " cm · " + room.label + "</div></div>" + realPhotoHtml();
  }
  function viewsHtml() {
    return '<div class="cc-stage__views">' + [["frame", S.frame ? "Con la cornice" : "Anteprima"], ["sofa", "Sopra il divano"], ["bed", "Sopra il letto"], ["photo", "Foto originale"]].map(function (v) {
      return '<button type="button" data-view="' + v[0] + '" aria-pressed="' + (S.view === v[0]) + '">' + v[1] + "</button>";
    }).join("") + "</div>";
  }
  // Con la foto originale visibile resta un pulsante per tornare all'anteprima.
  var backBtn = null;
  function showBack(on) {
    var g = gallery();
    if (!g) return;
    if (!backBtn) {
      backBtn = document.createElement("div");
      backBtn.className = "cc-stage__views";
      backBtn.style.zIndex = "6";
      backBtn.innerHTML = '<button type="button">Vedi con la cornice</button>';
      backBtn.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); S.view = "frame"; renderStage(); });
      g.appendChild(backBtn);
    }
    backBtn.firstChild.textContent = S.frame ? "Vedi con la cornice" : "Vedi l'anteprima";
    backBtn.hidden = !on;
  }

  // Ritocco a mano scelto (richiesta dell'utente del 29/10/2026): in un angolo della foto il dettaglio di una tela
  // ritoccata, per far capire che il colore viene steso a mano sopra la stampa e crea rilievo. Clic per ingrandire.
  var retouchFig = null;
  function showRetouch() {
    var on = kind === "canvas" && S.retouch;
    if (!retouchFig && !on) return;
    var g = gallery();
    if (!g) return;
    if (!retouchFig) {
      if (getComputedStyle(g).position === "static") g.style.position = "relative";
      retouchFig = document.createElement("figure");
      retouchFig.className = "cc-real cc-retouch";
      retouchFig.title = "Ingrandisci";
      retouchFig.innerHTML = '<img src="' + cfg.assetBase + 'ritocco-a-mano.jpg" alt="Dettaglio di una tela ritoccata a mano: colore a rilievo steso sopra la stampa">' +
        "<figcaption>Ritocco a mano: colore a rilievo steso a mano sopra la stampa per un effetto materico e 3D</figcaption>";
      retouchFig.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); retouchFig.classList.toggle("cc-real--big"); });
      g.appendChild(retouchFig);
    }
    retouchFig.hidden = !on;
  }

  // ---------- Realtà aumentata ----------
  // Il quadro con la cornice scelta diventa un modello 3D a grandezza reale (GLB costruito qui, con la
  // faccia anteriore dipinta su un canvas) mostrato da <model-viewer>: WebXR su Android, Quick Look su
  // iPhone (USDZ generato da model-viewer), appoggiato alla parete e senza possibilità di ridimensionarlo.
  var MODEL_VIEWER = "https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js";
  var TEX_MAX = 2048;

  function loadImg(src) {
    return new Promise(function (ok, ko) {
      var i = new Image();
      i.crossOrigin = "anonymous";
      i.onload = function () { ok(i); };
      i.onerror = function () { ko(new Error("Immagine non caricata")); };
      i.src = src;
    });
  }

  // Faccia anteriore: cornice a 9 sezioni (come border-image ... stretch) + quadro ritagliato dal riquadro.
  function paintFront(size) {
    var f = S.frame;
    var fcm = f ? f.w / 10 : 0, gcm = f && f.gap ? f.gap / 10 : 0;
    var mcm = matCm(size);
    var outW = size.w + 2 * (fcm + gcm), outH = size.h + 2 * (fcm + gcm);
    var k = Math.min(TEX_MAX / outW, TEX_MAX / outH);
    var c = document.createElement("canvas");
    c.width = Math.round(outW * k); c.height = Math.round(outH * k);
    var x = c.getContext("2d");
    var B = Math.round(fcm * k), G = Math.round(gcm * k), M = Math.round(mcm * k);
    var art = cfg.image.indexOf("//") === 0 ? location.protocol + cfg.image : cfg.image;
    return Promise.all([loadImg(art), f ? loadImg(imgUrl(f)) : null]).then(function (imgs) {
      var a = imgs[0], fr = imgs[1];
      x.fillStyle = "#1b1917";
      x.fillRect(0, 0, c.width, c.height);
      var IW = a.naturalWidth, IH = a.naturalHeight, b = cfg.box;
      var bx = b.x0 * IW, by = b.y0 * IH, bw = (b.x1 - b.x0) * IW, bh = (b.y1 - b.y0) * IH, t = (size.w - 2 * mcm) / (size.h - 2 * mcm);
      var rx = bx, ry = by, rw = bw, rh = bh;
      if (bw / bh > t) { rw = bh * t; rx = bx + (bw - rw) / 2; } else { rh = bw / t; ry = by + (bh - rh) / 2; }
      if (M) { x.fillStyle = S.mat ? matHex() : "#e9e6e0"; x.fillRect(B + G, B + G, c.width - 2 * (B + G), c.height - 2 * (B + G)); } // doppio plexiglass: tinta di parete neutra
      x.drawImage(a, rx, ry, rw, rh, B + G + M, B + G + M, c.width - 2 * (B + G + M), c.height - 2 * (B + G + M));
      if (fr && B > 0) {
        var W = fr.naturalWidth, H = fr.naturalHeight, sx = f.slice * W, sy = f.slice * H, cw = c.width, ch = c.height;
        x.drawImage(fr, 0, 0, sx, sy, 0, 0, B, B);
        x.drawImage(fr, W - sx, 0, sx, sy, cw - B, 0, B, B);
        x.drawImage(fr, 0, H - sy, sx, sy, 0, ch - B, B, B);
        x.drawImage(fr, W - sx, H - sy, sx, sy, cw - B, ch - B, B, B);
        x.drawImage(fr, sx, 0, W - 2 * sx, sy, B, 0, cw - 2 * B, B);
        x.drawImage(fr, sx, H - sy, W - 2 * sx, sy, B, ch - B, cw - 2 * B, B);
        x.drawImage(fr, 0, sy, sx, H - 2 * sy, 0, B, B, ch - 2 * B);
        x.drawImage(fr, W - sx, sy, sx, H - 2 * sy, cw - B, B, B, ch - 2 * B);
      }
      return new Promise(function (ok) { c.toBlob(function (blob) { ok({ blob: blob, w: outW / 100, h: outH / 100 }); }, "image/jpeg", 0.9); });
    });
  }

  // GLB minimo: faccia anteriore con la texture, fianchi e retro in tinta unita. Metri; il retro sta a z = 0.
  function buildGlb(front, jpeg, depth, sideColor) {
    var W = front.w / 2, H = front.h / 2, D = depth;
    function quad(p, n, uv) { return { p: p, n: n, uv: uv }; }
    var faceFront = quad([[-W, H, D], [-W, -H, D], [W, -H, D], [W, H, D]], [0, 0, 1], [[0, 0], [0, 1], [1, 1], [1, 0]]);
    var rest = [
      quad([[W, H, 0], [W, -H, 0], [-W, -H, 0], [-W, H, 0]], [0, 0, -1]),
      quad([[-W, H, 0], [-W, H, D], [W, H, D], [W, H, 0]], [0, 1, 0]),
      quad([[-W, -H, D], [-W, -H, 0], [W, -H, 0], [W, -H, D]], [0, -1, 0]),
      quad([[-W, H, 0], [-W, -H, 0], [-W, -H, D], [-W, H, D]], [-1, 0, 0]),
      quad([[W, H, D], [W, -H, D], [W, -H, 0], [W, H, 0]], [1, 0, 0]),
    ];
    function arrays(quads, withUv) {
      var pos = [], nor = [], uv = [], idx = [];
      quads.forEach(function (q, i) {
        q.p.forEach(function (v, j) { pos.push(v[0], v[1], v[2]); nor.push(q.n[0], q.n[1], q.n[2]); if (withUv) uv.push(q.uv[j][0], q.uv[j][1]); });
        var o = i * 4; idx.push(o, o + 1, o + 2, o, o + 2, o + 3);
      });
      return { pos: new Float32Array(pos), nor: new Float32Array(nor), uv: withUv ? new Float32Array(uv) : null, idx: new Uint16Array(idx) };
    }
    var A = arrays([faceFront], true), Bq = arrays(rest, false);
    var chunks = [], views = [], accessors = [], offset = 0;
    function addView(bytes, target) {
      var pad = (4 - (bytes.byteLength % 4)) % 4;
      views.push(target ? { buffer: 0, byteOffset: offset, byteLength: bytes.byteLength, target: target } : { buffer: 0, byteOffset: offset, byteLength: bytes.byteLength });
      chunks.push(bytes, new Uint8Array(pad));
      offset += bytes.byteLength + pad;
      return views.length - 1;
    }
    function addAccessor(arr, type, componentType, target, minmax) {
      var acc = { bufferView: addView(new Uint8Array(arr.buffer), target), componentType: componentType, count: arr.length / (type === "VEC3" ? 3 : type === "VEC2" ? 2 : 1), type: type };
      if (minmax) {
        var mn = [Infinity, Infinity, Infinity], mx = [-Infinity, -Infinity, -Infinity];
        for (var i = 0; i < arr.length; i += 3) for (var j = 0; j < 3; j++) { mn[j] = Math.min(mn[j], arr[i + j]); mx[j] = Math.max(mx[j], arr[i + j]); }
        acc.min = mn; acc.max = mx;
      }
      accessors.push(acc);
      return accessors.length - 1;
    }
    var p0 = { attributes: { POSITION: addAccessor(A.pos, "VEC3", 5126, 34962, true), NORMAL: addAccessor(A.nor, "VEC3", 5126, 34962), TEXCOORD_0: addAccessor(A.uv, "VEC2", 5126, 34962) }, indices: addAccessor(A.idx, "SCALAR", 5123, 34963), material: 0 };
    var p1 = { attributes: { POSITION: addAccessor(Bq.pos, "VEC3", 5126, 34962, true), NORMAL: addAccessor(Bq.nor, "VEC3", 5126, 34962) }, indices: addAccessor(Bq.idx, "SCALAR", 5123, 34963), material: 1 };
    var imageView = addView(new Uint8Array(jpeg));
    var json = {
      asset: { version: "2.0", generator: "Luxarts configuratore cornici" },
      scene: 0, scenes: [{ nodes: [0] }], nodes: [{ mesh: 0, name: "Quadro" }],
      meshes: [{ primitives: [p0, p1] }],
      materials: [
        { name: "Fronte", pbrMetallicRoughness: { baseColorTexture: { index: 0 }, metallicFactor: 0, roughnessFactor: 0.85 } },
        { name: "Fianchi", pbrMetallicRoughness: { baseColorFactor: sideColor, metallicFactor: 0, roughnessFactor: 0.9 } },
      ],
      textures: [{ source: 0, sampler: 0 }],
      samplers: [{ magFilter: 9729, minFilter: 9729 }],
      images: [{ bufferView: imageView, mimeType: "image/jpeg" }],
      buffers: [{ byteLength: offset }],
      bufferViews: views,
      accessors: accessors,
    };
    var jsonBytes = new TextEncoder().encode(JSON.stringify(json));
    var jsonPad = (4 - (jsonBytes.length % 4)) % 4;
    var total = 12 + 8 + jsonBytes.length + jsonPad + 8 + offset;
    var out = new Uint8Array(total), dv = new DataView(out.buffer), at = 0;
    dv.setUint32(0, 0x46546c67, true); dv.setUint32(4, 2, true); dv.setUint32(8, total, true); at = 12;
    dv.setUint32(at, jsonBytes.length + jsonPad, true); dv.setUint32(at + 4, 0x4e4f534a, true); at += 8;
    out.set(jsonBytes, at); for (var s = 0; s < jsonPad; s++) out[at + jsonBytes.length + s] = 0x20; at += jsonBytes.length + jsonPad;
    dv.setUint32(at, offset, true); dv.setUint32(at + 4, 0x004e4942, true); at += 8;
    chunks.forEach(function (ch) { out.set(ch, at); at += ch.byteLength; });
    return new Blob([out], { type: "model/gltf-binary" });
  }

  var arModal = null, mvLoading = null;
  function loadModelViewer() {
    if (window.customElements && customElements.get("model-viewer")) return Promise.resolve();
    if (!mvLoading) mvLoading = new Promise(function (ok, ko) {
      var s = document.createElement("script");
      s.type = "module"; s.src = MODEL_VIEWER; s.onload = ok; s.onerror = function () { ko(new Error("Visore 3D non caricato")); };
      document.head.appendChild(s);
    }).then(function () { return customElements.whenDefined("model-viewer"); });
    return mvLoading;
  }

  function openAR() {
    var size = parseSize(currentSizeValue());
    if (!size) return;
    if (!arModal) {
      arModal = document.createElement("div");
      arModal.className = "cc-ar";
      arModal.setAttribute("role", "dialog");
      arModal.setAttribute("aria-label", "Prova sulla tua parete");
      arModal.addEventListener("click", function (e) { if (e.target === arModal || e.target.closest("[data-ar-close]")) closeAR(); });
      document.body.appendChild(arModal);
    }
    var label = (S.frame ? S.frame.name + " · " : "") + size.label;
    arModal.innerHTML = '<div class="cc-ar__box"><div class="cc-ar__head"><b>Sulla tua parete</b><button type="button" data-ar-close aria-label="Chiudi">✕</button></div>' +
      '<div class="cc-ar__view"><p class="cc-ar__msg">Preparo il quadro in 3D…</p></div><p class="cc-ar__hint">' + esc(label) + " · a grandezza reale</p></div>";
    arModal.hidden = false;
    document.documentElement.style.overflow = "hidden";
    var depth = S.frame ? 0.04 : 0.025;
    var side = S.frame ? [0.12, 0.11, 0.1, 1] : [0.9, 0.89, 0.87, 1];
    Promise.all([paintFront(size), loadModelViewer()]).then(function (r) {
      var front = r[0];
      return front.blob.arrayBuffer().then(function (buf) {
        var glb = buildGlb(front, buf, depth, side);
        var url = URL.createObjectURL(glb);
        var view = arModal.querySelector(".cc-ar__view");
        view.innerHTML = '<model-viewer src="' + url + '" alt="' + esc(product.title + " con cornice") + '" ar ar-modes="webxr scene-viewer quick-look" ar-placement="wall" ar-scale="fixed" camera-controls touch-action="pan-y" shadow-intensity="0.6" exposure="1.05" style="width:100%;height:100%;background:#f3f1ec">' +
          '<button slot="ar-button" class="cc-ar__go">Vedilo sulla tua parete</button></model-viewer>' +
          '<p class="cc-ar__msg cc-ar__desk" hidden>Apri questa pagina dal telefono per vedere il quadro sulla tua parete con la fotocamera.</p>';
        var mv = view.querySelector("model-viewer");
        mv.addEventListener("load", function () { if (!mv.canActivateAR) view.querySelector(".cc-ar__desk").hidden = false; });
      });
    }).catch(function (err) {
      var m = arModal.querySelector(".cc-ar__msg");
      if (m) m.textContent = "Non riesco a preparare la vista: " + err.message;
    });
  }
  function closeAR() {
    if (!arModal) return;
    arModal.hidden = true;
    arModal.innerHTML = "";
    document.documentElement.style.overflow = "";
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAR(); });

  // ---------- Eventi ----------
  root.addEventListener("click", function (e) {
    var b = e.target.closest("button");
    if (!b || b.disabled) return;
    e.preventDefault();
    if (b.hasAttribute("data-ar")) { openAR(); return; }
    if (b.hasAttribute("data-mode")) {
      S.mode = b.getAttribute("data-mode");
      if (S.mode === "base") { S.frame = null; if (S.mat && S.view === "photo") S.view = "frame"; } // solo telaio con passe-partout: anteprima senza cornice
      else if (!S.frame) { S.tier = "std"; S.autoPicked = false; } // tornando a "Con cornice" si riparte dalla prima Standard (nera)
      S.touched = true;
      render();
      return;
    }
    if (b.hasAttribute("data-nav")) {
      var r = root.querySelector(".cc__rail");
      if (r) r.scrollBy({ left: Number(b.getAttribute("data-nav")) * r.clientWidth * 0.8, behavior: "smooth" });
      return;
    }
    if (b.hasAttribute("data-all")) { S.expanded = !S.expanded; render(); return; }
    if (b.hasAttribute("data-mat")) {
      S.mat = b.getAttribute("data-mat") || null;
      if (S.mat && S.glass === "doppio") S.glass = null;
      if (S.mat) { S.touched = true; if (S.view === "photo") S.view = "frame"; } // mostra subito l'anteprima del passe-partout
      render();
      return;
    }
    if (b.hasAttribute("data-tier")) {
      // Cambiando scheda si sceglie anche una cornice di quella scheda (l'ultima usata, altrimenti la prima / quella di partenza)
      var tier = b.getAttribute("data-tier");
      if (tier !== S.tier) {
        S.lastByTier = S.lastByTier || {};
        if (S.frame) S.lastByTier[S.frame.std ? "std" : "premium"] = S.frame;
        S.tier = tier;
        var last = S.lastByTier[tier], stdsNow = stdList(currentSizeValue());
        S.frame = tier === "std" ? stdsNow.filter(function (f) { return last && f.id === last.id; })[0] || stdsNow[0] || null : last || null;
        if (!S.frame) S.autoPicked = false;
        if (S.frame) { S.touched = true; if (S.view === "photo") S.view = "frame"; }
      }
      render();
      return;
    }
    if (b.hasAttribute("data-retouch")) { S.retouch = b.getAttribute("data-retouch") === "1"; render(); return; }
    // Larghezza e colore del passe-partout si vedono subito nell'anteprima (anche senza cornice)
    var matPreview = function () { if (S.mat) { S.touched = true; if (S.view === "photo") S.view = "frame"; } };
    if (b.hasAttribute("data-matw")) { S.matW = Number(b.getAttribute("data-matw")); matPreview(); render(); return; }
    if (b.hasAttribute("data-matcolor")) { S.matColor = b.getAttribute("data-matcolor"); matPreview(); render(); return; }
    if (b.hasAttribute("data-glass")) { S.glass = b.getAttribute("data-glass") || null; if (S.glass === "doppio") S.mat = null; render(); return; }
    if (b.hasAttribute("data-color")) { S.color = b.getAttribute("data-color") || null; S.shown = PAGE; }
    else if (b.hasAttribute("data-style")) { S.style = b.getAttribute("data-style") || null; S.shown = PAGE; }
    else if (b.hasAttribute("data-more")) { S.shown += PAGE * 2; }
    else if (b.hasAttribute("data-frame")) {
      var id = b.getAttribute("data-frame");
      S.frame = id ? (stdList(currentSizeValue()).filter(function (f) { return f.id === id; })[0] || S.data.frames.filter(function (f) { return f.id === id; })[0]) : null;
      S.touched = true;
      if (S.view === "photo") S.view = "frame";
    }
    render();
  });

  // Il cambio di misura lo gestisce il tema: si rilegge la variante appena aggiornata.
  document.addEventListener("change", function (e) {
    if (e.target.closest && e.target.closest("variant-selects, variant-radios")) setTimeout(function () { hideMaterial(); render(); }, 60);
  });

  // Aggiunta al carrello: quadro nella versione base + riga della cornice con il suo prezzo.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || form.matches(".installment")) return;
    if (S.mode === "frame" && !S.frame) { e.preventDefault(); e.stopImmediatePropagation(); alertBox("Scegli una cornice, oppure " + (kind === "poster" ? "Poster arrotolato" : "Solo telaio") + " per acquistarlo senza cornice."); return; }
    if (!S.frame && !(kind === "canvas" && (S.mat || S.retouch))) return;
    if (kind === "canvas" && S.retouch && !retouchAddon()) { e.preventDefault(); e.stopImmediatePropagation(); alertBox("Il ritocco a mano non è ancora disponibile."); return; }
    if (kind === "canvas" && S.mat && !printedMat()) { e.preventDefault(); e.stopImmediatePropagation(); alertBox("L'effetto passe-partout non è ancora disponibile."); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    var sizeValue = currentSizeValue();
    var size = parseSize(sizeValue);
    var base = baseVariantFor(sizeValue);
    var stdV = S.frame && S.frame.std ? stdVariant(S.frame, sizeValue) : null;
    var price = S.frame && !S.frame.std && size && linePrice(size);
    var fv = price && frameVariant(price);
    if (!base || (S.frame && !(S.frame.std ? stdV : fv))) { alertBox("Questa cornice non è disponibile per la misura scelta."); return; }
    var qtyInput = form.querySelector('[name="quantity"]') || mainForm().querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var link = String(Date.now());
    var paintingLabel = product.title + " " + size.label;
    // Codici solo in proprietà nascoste (con "_"): non si vedono in carrello e checkout, restano nell'ordine per la produzione.
    // Cornice standard: si compra la variante "CON CORNICE <colore>" del prodotto, senza riga cornice a parte.
    var items = [{ id: stdV ? stdV.id : base.id, quantity: qty, properties: { "_cc_link": link } }];
    if (S.frame) {
      items[0].properties["Cornice"] = S.frame.name;
      items[0].properties["_Codice cornice"] = S.frame.code;
      if (!S.frame.std) items.push({ id: fv, quantity: qty, properties: { "Cornice": S.frame.name, "Profilo": cm(S.frame.w / 10) + " cm", "Per il quadro": paintingLabel, "_Codice cornice": S.frame.code, "_cc_frame": S.frame.id, "_cc_img": S.frame.img, "_cc_link": link } });
    }
    var ps = printSize(size);
    if (kind === "canvas" && S.mat) {
      var pcols = matColors(), pi = pcols.map(function (c) { return c.code; }).indexOf(S.matColor);
      var pmText = "effetto stampato sulla tela, " + (pi >= 0 ? matLabel(pcols[pi], pi).toLowerCase() : "colore da definire") + ", larghezza " + S.matW + " cm (compreso nella misura, immagine " + cm(ps.w) + "×" + cm(ps.h) + " cm)";
      items[0].properties["Passe-partout"] = pmText;
      var pmProps = { "Passe-partout": pmText, "Per il quadro": paintingLabel, "_cc_link": link };
      if (S.matColor) pmProps["_Codice passe-partout"] = S.matColor;
      items.push({ id: printedMat().variantId, quantity: qty, properties: pmProps });
    }
    if (kind === "canvas" && S.retouch) {
      items[0].properties["Ritocco a mano"] = "Sì";
      items.push({ id: retouchAddon().variantId, quantity: qty, properties: { "Ritocco a mano": "un'artista ritocca a mano la tela, effetto materico", "Per il quadro": paintingLabel, "_cc_link": link } });
    }
    if (kind === "poster" && S.mat) {
      var mcols = matColors(), mi = mcols.map(function (c) { return c.code; }).indexOf(S.matColor);
      items[1].properties["Passe-partout"] = "spessore " + (S.mat === "pas28" ? "2,8" : "1,4") + " mm, " + (mi >= 0 ? matLabel(mcols[mi], mi).toLowerCase() : "colore da definire") + ", larghezza " + S.matW + " cm (compreso nella misura, stampa " + cm(ps.w) + "×" + cm(ps.h) + " cm)";
      if (S.matColor) items[1].properties["_Codice passe-partout"] = S.matColor;
    }
    if (kind === "poster" && S.glass === "plexi") items[1].properties["Plexiglass"] = "Plexiglass";
    if (kind === "poster" && S.glass === "doppio") items[1].properties["Plexiglass"] = "Doppio plexiglass fronte e retro, bordo trasparente " + S.matW + " cm (stampa " + cm(ps.w) + "×" + cm(ps.h) + " cm)";
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute("aria-busy", "true");
    // Sezioni del carrello laterale da ridisegnare, chieste come fa il modulo prodotto di Hyper.
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sections } }));
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items, sections: sections }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || "Aggiunta non riuscita");
        var drawer = document.querySelector("cart-drawer"), pubsub = window.FoxTheme && window.FoxTheme.pubsub;
        if (!drawer || !pubsub) { window.location.href = "/cart"; return; }
        return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = res.j.sections;
          pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          if (btn) btn.removeAttribute("aria-busy");
          drawer.show();
        });
      })
      .catch(function (err) { if (btn) btn.removeAttribute("aria-busy"); alertBox(err.message); });
  }, true);

  function alertBox(msg) {
    var n = root.querySelector(".cc__note") || document.createElement("div");
    n.className = "cc__note";
    n.style.color = "#b3262d";
    n.textContent = msg;
    root.appendChild(n);
  }

  fetch(cfg.dataUrl).then(function (r) { return r.json(); }).then(function (data) {
    S.data = data;
    // Blocco "disponibilità" del tema vuoto (prodotti senza scorte): occupa solo spazio.
    document.querySelectorAll(".product__block--inventory").forEach(function (b) { if (!b.textContent.trim()) b.style.display = "none"; });
    hideMaterial();
    render();
    watchPicker();
  }).catch(function () { root.hidden = true; });
})();
